import React, { Component, Fragment } from 'react';
import axios from 'axios';
import Navigation from '../../components/navigation.components';
import { withOktaAuth } from '@okta/okta-react';

import { Button, Modal, Accordion } from 'react-bootstrap';

import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";

import { MDBDataTable } from 'mdbreact';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'mdbreact/dist/css/mdb.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPen, faTrash } from '@fortawesome/free-solid-svg-icons'

import { MSG } from '../../constants';

class Sites extends Component {

	state = {
		page: {
			loaded: true
		},
		sites: [],
		formData: {
			name: "",
			address: ""
		},
		formErrors: [],
		formStatus: {
			submitted: false
		},
		modal: {
			sites: false,
			deleteSites: false
		},
		selected: null,
	}

	componentDidMount() {
		this.getAllSites();
	}

	getAllSites = async () => {
		let requests = await axios.get('/api/sites', {
			headers: {
				Authorization: 'Bearer ' + this.props.authState.accessToken.accessToken
			}
		});

		let { status, data, error } = requests.data;
		if (status) {
			let { sites } = this.state;
			sites = data;
			this.setState({ ...this.state, sites });
		}
	}

	addNewSiteModalHandler = e => {
		e.preventDefault();
		let { modal } = this.state;
		modal.sites = true;
		this.setState({ modal });
	}

	closeSitesModalHandler = e => {
		e && e.hasOwnProperty('preventDefault') && e.preventDefault();
		let { modal, formData, formStatus, formErrors } = this.state;
		modal.sites = false;
		formData = {
			name: "",
			address: ""
		};
		formErrors = [];
		formStatus.submitted = false;
		this.setState({ ...this.state, modal, formData, formStatus, formErrors }, () => this.getAllSites());
	}

	inputChangeHandler = e => {
		let { formData, formErrors } = this.state;
		formData[e.target.name] = e.target.value;

		if (formErrors.includes(e.target.name)) {
			let idx = formErrors.indexOf(e.target.name);
			formErrors.splice(idx, 1);
		}

		this.setState({ ...this.state, formData, formErrors });
	}

	submitSitesHandler = e => {
		let { formStatus, formErrors, formData } = { ...this.state };

		formErrors = [];
		Object.keys(formData).map(key => {
			if (formData[key] === "") {
				if (!formErrors.includes(key)) formErrors.push(key);
			}
		})


		if (formErrors.length > 0) {
			this.setState({ ...this.state, formErrors });
		} else {
			formStatus.submitted = true;
			this.setState({ ...this.state, formStatus }, () => this.sendSitesRequest());
		}
	}

	sendSitesRequest = () => {
		let { formStatus, formData, modal } = { ...this.state };

		let data = {
			name: formData.name,
			address: formData.address
		};

		if (formData.hasOwnProperty('id')) {
			data.id = formData.id;
		}

		axios.post('/api/sites', data,
			{
				headers: {
					Authorization: 'Bearer ' + this.props.authState.accessToken.accessToken
				}
			}).then(response => {
				formData = {
					name: "",
					address: ""
				}
				modal.sites = false;
				formStatus.submitted = false;
				this.setState({ ...this.state, formStatus, formData, modal }, () => this.getAllSites());

				toast.success('Successfully created notification', {
					position: "bottom-left",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: false,
					draggable: true,
					progress: undefined,
				});

			}).catch(err => {
				toast.error("[Error code: sendSitesRequest] "+MSG.error, {
					position: "bottom-left",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: false,
					draggable: true,
					progress: undefined,
				});

				formStatus.submitted = false;
				this.setState({ ...this.state, formStatus });
			})
	}

	updateSitesModalHandler = (e, site) => {
		e.preventDefault();
		let { modal, formData } = { ...this.state };

		formData = {
			id: site._id,
			name: site.siteName,
			address: site.siteAddress,
		};

		modal.sites = true;
		this.setState({ ...this.state, formData, modal });
	}

	closeDeleteSites = e => {
		let { modal, selected } = this.state;
		modal.deleteSites = false;
		selected = null;
		this.setState({ ...this.state, selected, modal });
	}

	deleteSitesModalHandler = (e, site) => {
		let { modal, selected } = this.state;
		modal.deleteSites = true;
		selected = site;
		this.setState({ ...this.state, modal, selected });
	}

	submitDeleteRequest = e => {
		e.preventDefault();
		let formStatus = this.state.formStatus;
		formStatus.submitted = true;
		this.setState({ ...this.state, formStatus }, () => {
			this.deleteSitesRequest()
		});
	}

	deleteSitesRequest = () => {
		let { modal, selected, formStatus } = this.state;
		axios.delete(`/api/sites/${selected._id}`, {
			headers: {
				Authorization: 'Bearer ' + this.props.authState.accessToken.accessToken
			}
		}).then(response => {
			modal.deleteSites = false;
			selected = null;
			formStatus.submitted = false;
			this.setState({ ...this.state, modal, selected, formStatus }, () => this.getAllSites());

			toast.success('Successfully deleted notification', {
				position: "bottom-left",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: false,
				draggable: true,
				progress: undefined,
			});

		}).catch(err => {
			formStatus.submitted = false;
			this.setState({ ...this.state, formStatus });
			toast.error("[Error code: deleteSitesRequest] "+MSG.error, {
				position: "bottom-left",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: false,
				draggable: true,
				progress: undefined,
			});
		})
	}


	capitalize(str) {
		return str ? str.charAt(0).toUpperCase() + str.slice(1) : "";
	}

	render() {
		let { page, formData, formStatus, formErrors, modal, sites } = this.state;

		let data = {
			columns: [
				{ label: 'Site Name', field: 'name', sort: 'desc' },
				{ label: 'Address', field: 'address' },
				{ label: 'Actions', field: 'actions' },
			],
			rows: []
		}

		if (sites.length > 0) {
			sites.map(site => {
				data.rows.push({
					actions: <>
						<button className='btn btn-sm btn-danger' style={{ margin: 0 }} onClick={e => this.deleteSitesModalHandler(e, site)} ><FontAwesomeIcon icon={faTrash} /></button> {" "}
						<button className='btn btn-sm btn-primary' style={{ margin: 0 }} onClick={e => this.updateSitesModalHandler(e, site)} ><FontAwesomeIcon icon={faPen} /></button>
					</>,
					name: site.siteName,
					address: site.siteAddress
				});
			})
		}

		return <>
			<Navigation />
			<ToastContainer
				position="bottom-left"
				autoClose={5000}
				hideProgressBar={true}
				newestOnTop={true}
				closeOnClick
				rtl={false}
				pauseOnFocusLoss
				draggable={false}
				pauseOnHover
			/>

			{page.loaded ?
				<div className='container'>
					<div className='row mt-3'>
						<div className='col-12' style={{ textAlign: 'right' }}>
							<button className='btn btn-primary' onClick={e => this.addNewSiteModalHandler(e)}>Add New Site</button>
						</div>
					</div>
					<div className="row mt-3">
						<div className="col-12">
							<MDBDataTable
								responsive
								striped
								bordered
								hover
								noBottomColumns
								data={data}
								entriesOptions={[10, 20, 25]}
							// order={['submitted_at', 'desc']}
							/>
						</div>
					</div>
				</div>
				: <>Loading...</>
			}

			<Modal
				show={modal.sites}
				size="lg"
				onHide={e => this.closeSitesModalHandler(e)}
				backdrop="static"
				keyboard={false}
			>
				<Modal.Header closeButton={!formStatus.submitted}>
					<Modal.Title>{formData.hasOwnProperty('id') ? "Update" : "Create"} Notification</Modal.Title>
				</Modal.Header>
				<Modal.Body>

					<form>
						<div className='row'>
							<div className='col-12'>
								<label htmlFor="name">Site Name *</label>
								<input
									type="text"
									name='name'
									id='name'
									value={formData.name}
									placeholder=""
									className={`form-control ${formErrors.includes('name') ? 'is-invalid' : ''}`}
									onChange={e => this.inputChangeHandler(e)}
									disabled={formStatus.submitted}
								/>
							</div>
						</div>

						<div className='row'>
							<div className='col-12 mt-3'>
								<label htmlFor='recipients'>Address *</label>
								<textarea
									name="address"
									id="address"
									style={{ width: "100%", resize: 'none' }}
									value={formData.address}
									onChange={e => this.inputChangeHandler(e)}
									className={`form-control ${formErrors.includes('address') ? 'is-invalid' : ''}`}
									rows={2}
									disabled={formStatus.submitted}
								/>
							</div>
						</div>

					</form>
				</Modal.Body>
				<Modal.Footer>
					<Button variant="secondary" onClick={e => this.closeSitesModalHandler(e)} disabled={formStatus.submitted}>
						Close
					</Button>
					<Button variant="primary" onClick={e => this.submitSitesHandler(e)} disabled={formStatus.submitted}>
						Submit
					</Button>
				</Modal.Footer>
			</Modal>


			{/* Delete Modal */}
			<Modal
				show={modal.deleteSites}
				size="lg"
				onHide={e => this.closeDeleteSites(e)}
				backdrop="static"
				keyboard={false}
			>
				<Modal.Header closeButton={!formStatus.submitted}>
					<Modal.Title>Delete Notification</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className='row'>
						<div className='col-12'>
							<p>
								Are you sure you want to delete {this.capitalize(this.state.selected?.siteName)}
							</p>
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<Button variant="secondary" onClick={this.closeDeleteSites} disabled={formStatus.submitted}>
						Close
					</Button>
					<Button variant="primary" onClick={this.submitDeleteRequest} disabled={formStatus.submitted}>
						Submit
					</Button>
				</Modal.Footer>
			</Modal>
		</>

	}
}


export default withOktaAuth(Sites);

